export default __webpack_public_path__ + "static/media/testimonial.a55a74f7.webp";